import React from "react";
import Header from "./Header";

const Layout = ({ children, pauseSlide, isPauseAudio, showBtn }) => {
  return (
    <>
      <Header pauseSlide={pauseSlide} isPauseAudio={isPauseAudio} showBtn={showBtn} />
      {children}
    </>
  );
};

export default Layout;
